<template>
	<div
		class="g-block-qrcode-nav-list"
		:class="{
			'g-block-qrcode-nav-list--edit': editable,
			'is-active': editable && active,
			'g-block-qrcode-nav-list--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			v-for="(item, index) in items"
			:key="item.id"
			class="g-block-qrcode-nav-list__item"
			:class="{ 'is-last': index === items.length - 1 }"
			@click="onItemClick($event, item)"
		>
			<div class="g-block-qrcode-nav-list__thumb">
				<img v-if="getImageUrl(item)" :src="getImageUrl(item)" alt="" />
				<i v-else class="mbm-iconfont mbm-tupian"></i>
			</div>
			<div class="g-block-qrcode-nav-list__text" :style="{ color: item.textColor }">
				{{ item.text }}
			</div>
			<i class="mbm-iconfont mbm-youjiantou g-block-qrcode-nav-list__arrow"></i>
		</div>
	</div>
</template>

<script>
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import {
		getQrcodeNavImageUrl,
		normalizeQrcodeNavListData,
	} from '../../../utils/qrcodeNav.js';

	export default {
		name: 'GQrcodeNavListShell',
		props: {
			data: {
				type: Object,
				required: true,
			},
			editable: {
				type: Boolean,
				default: false,
			},
			active: {
				type: Boolean,
				default: false,
			},
			h5: {
				type: Boolean,
				default: false,
			},
		},
		emits: ['select'],
		computed: {
			items() {
				return normalizeQrcodeNavListData(this.data).items;
			},
		},
		methods: {
			getImageUrl(item) {
				return getQrcodeNavImageUrl(item.image);
			},
			onWrapClick(e) {
				if (!this.editable) return;
				e?.stopPropagation?.();
				this.$emit('select');
			},
			onItemClick(e, item) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.h5 && item.jumpLink?.type) {
					e?.stopPropagation?.();
					navigateJumpLink(item.jumpLink, {
						apiRequest: this.$apiRequest,
					});
				}
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-qrcode-nav-list {
		background: #fff;
		box-sizing: border-box;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-qrcode-nav-list__item {
		display: flex;
		align-items: center;
		gap: 12px;
		min-height: 72px;
		padding: 12px 0;
		border-bottom: 1px solid #f0f0f0;
		box-sizing: border-box;
		cursor: pointer;

		&.is-last {
			border-bottom: none;
		}

		.g-block-qrcode-nav-list--h5 & {
			gap: 0.24rem;
			min-height: 1.44rem;
			padding: 0.24rem 0;
		}
	}

	.g-block-qrcode-nav-list__thumb {
		flex-shrink: 0;
		width: 48px;
		height: 48px;
		border-radius: 4px;
		overflow: hidden;
		background: #f0f0f0;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			display: block;
		}

		i {
			font-size: 20px;
			color: #bfbfbf;
		}

		.g-block-qrcode-nav-list--h5 & {
			width: 0.96rem;
			height: 0.96rem;
			border-radius: 0.08rem;

			i {
				font-size: 0.4rem;
			}
		}
	}

	.g-block-qrcode-nav-list__text {
		flex: 1;
		min-width: 0;
		font-size: 14px;
		line-height: 1.5;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.g-block-qrcode-nav-list--h5 & {
			font-size: 0.28rem;
		}
	}

	.g-block-qrcode-nav-list__arrow {
		flex-shrink: 0;
		font-size: 12px;
		color: #ccc;

		.g-block-qrcode-nav-list--h5 & {
			font-size: 0.24rem;
		}
	}
</style>
